"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeartSmileIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.stroke, stroke = _c === void 0 ? 'black' : _c, size = _a.size, rest = __rest(_a, ["fill", "stroke", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 26 24" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M25 7.21739C25 13.6945 17.7044 19.8677 13.5637 22.632C13.2237 22.8589 12.7845 22.8462 12.454 22.6056C8.31647 19.5937 1 13.7038 1 7.21739C1 3.78362 3.91015 1 7.5 1C9.81577 1 11.8487 2.15837 13 3.90239C14.1513 2.15837 16.1842 1 18.5 1C22.0899 1 25 3.78362 25 7.21739Z", stroke: stroke, strokeWidth: "1", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M7 12C10 17.3333 16 17.3333 19 12", stroke: stroke, strokeWidth: "1", strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.stroke, stroke = _c === void 0 ? 'black' : _c, size = _a.size, rest = __rest(_a, ["fill", "stroke", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 34 32" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M33 9.62318C33 18.2594 23.2725 26.4902 17.7516 30.1759C17.2983 30.4786 16.7127 30.4615 16.272 30.1408C10.7553 26.1249 1 18.2717 1 9.62318C1 5.04482 4.8802 1.33333 9.66667 1.33333C12.7544 1.33333 15.4649 2.87782 17 5.20318C18.5351 2.87782 21.2456 1.33333 24.3333 1.33333C29.1198 1.33333 33 5.04482 33 9.62318Z", stroke: stroke, strokeWidth: "1.5", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M9 16C13 23.1111 21 23.1111 25 16", stroke: stroke, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
};
var HeartSmileIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.HeartSmileIcon = HeartSmileIcon;
//# sourceMappingURL=HeartSmileIcon.js.map